import { render, staticRenderFns } from "./SDIStrategiesResultsSection.vue?vue&type=template&id=1a00593a&scoped=true"
import script from "./SDIStrategiesResultsSection.vue?vue&type=script&lang=js"
export * from "./SDIStrategiesResultsSection.vue?vue&type=script&lang=js"
import style0 from "./SDIStrategiesResultsSection.vue?vue&type=style&index=0&id=1a00593a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00593a",
  null
  
)

export default component.exports